import type { AxiosRequestConfig } from 'axios';
import type { SurgicalGuideCaseData, SurgicalGuideUserPreferenceData } from '@/stores/surgicalGuide/surgicalGuide.types';
import { apiToState, stateToRequest, surgeonPreferencesToState, userStateToRequest } from '@/api/surgicalGuide/mapping';
import {
    getCaseSettings,
    putCaseSettings,
    getUserPreferences,
    putUserPreferences
} from '@/api/surgicalGuide/request';

export async function loadCaseSurgicalGuideSettings(
    caseId: number,
    config?: AxiosRequestConfig,
): Promise<SurgicalGuideCaseData | null> {
    const data = await getCaseSettings(caseId, config);

    if (data) {
        return apiToState(data);
    }

    return null;
}

export async function saveCaseSettings(
    caseId: number,
    data: SurgicalGuideCaseData,
    includeCrNumber = false,
    config?: AxiosRequestConfig,
): Promise<void> {
    const request = stateToRequest(data, includeCrNumber);
    await putCaseSettings(caseId, request, config);
}

export async function loadSurgicalGuideUserPreferences(
    surgeonId: number,
    config?: AxiosRequestConfig,
): Promise<SurgicalGuideUserPreferenceData | null> {
    const data = await getUserPreferences(surgeonId, config);

    if (data) {
        return surgeonPreferencesToState(data);
    }

    return null;
}

export async function saveSurgicalGuidePreferences(
    surgeonId: number,
    data: SurgicalGuideUserPreferenceData,
    config?: AxiosRequestConfig,
): Promise<void> {
    const request = userStateToRequest(data);
    await putUserPreferences(surgeonId, request, config);
}
